module.exports = __webpack_public_path__ + "media/images/front/materials/solid_surface-964e407bcff04629a10ada473580a500.jpg";